import { Chip } from 'primereact/chip';

const TagText = (props: { text: string }) => {

    return <div className='tag-content'>
        <Chip label={props.text} style={{ backgroundColor: '#DFF6FD', borderRadius: '0px' }} />
    </div>
}

export default TagText;